module.exports = __webpack_public_path__ + "img/tinder.adc0c1d0.svg";